<template>
  <div class="menu">
    <div class="menu-header">
      <a class="back" @click="back" v-if="level > 0" v-html="backIcon" />
      <div class="menu-title">
        {{ activeItem ? activeItem.title : "Menu" }}
      </div>
      <a class="close" @click="close" v-html="closeIcon" />
    </div>

    <div class="content limit">
      <transition :name="`items-${dir}`" mode="out-in">
        <div :key="level">
          <div class="items">
            <div class="menu-item" v-for="item in currentItems" :key="item.title">
              <a class="item" :href="item.url" @click.prevent="click(item)">
                <div class="title" v-text="item.title" :class="{ normal: level == 2 }" />
              </a>
            </div>
          </div>
          <div v-if="level === 0 && shops[0]">
            <select class="country_code" onchange="window.location = this.value">
              <option v-for="(shop, index) in shops" :key="index" :value="shop.url">
                {{ shop.name }}
              </option>
            </select>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileMenu",
  selector: "#mobile-menu",
  props: {
    items: { type: Array, required: true },
    closeIcon: { type: String, required: true },
    backIcon: { type: String, required: true },
    shops: { type: Array, required: true }
  },
  data() {
    return {
      level: 0,
      dir: "right",
      activeItem: null
    };
  },
  computed: {
    currentItems() {
      return this.activeItem ? this.activeItem.sublinks || this.activeItem.subsublinks : this.items;
    }
  },
  methods: {
    close() {
      document.querySelector(".mobile-menu-container").classList.remove("show");
      document.body.classList.remove("lock");
    },
    back() {
      this.dir = "left";
      this.level--;
      this.activeItem = this.level > 0 ? (this.activeItem = this.items.find((x) => x.sublinks.some((sublink) => sublink.handle === this.activeItem.handle))) : null;
    },
    click(item) {
      const levels = parseInt(item.levels);
      if (levels > 0) {
        this.dir = "right";
        this.level++;
        this.activeItem = item;
      } else {
        window.location.href = item.url;
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  background: white;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transform: translate(-100%);
  transition: all 500ms ease;

  &-enter-active,
  &-leave-active {
    transition: opacity 0.2s ease-in-out;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }

  .menu-header {
    position: absolute;
    top: 20px;
    left: 16px;
    right: 16px;
    width: calc(100% - 32px);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .back {
    width: 16px;
    height: 16px;
    display: flex;

    ::v-deep svg {
      width: 100%;
      height: 100%;
    }
  }
  .close {
    width: 15px;
    color: black;
    // display: flex;
  }

  .menu-title {
    font-size: 16px;
    color: black;
    width: 100%;
    text-align: center;
  }

  .content {
    // margin: 48px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 16px;
    height: 100vh;
    justify-content: flex-start;
    padding-top: 100px;

    > div {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }
  }
  .items {
    height: 100%;
    &-right-enter-active,
    &-right-leave-active,
    &-left-enter-active,
    &-left-leave-active {
      transition: all 0.2s ease-in-out;
    }
    &-right-enter {
      opacity: 0;
      transform: translateX(20px);
    }
    &-right-leave-to {
      opacity: 0;
      transform: translateX(-20px);
    }
    &-left-enter {
      opacity: 0;
      transform: translateX(-20px);
    }
    &-left-leave-to {
      opacity: 0;
      transform: translateX(20px);
    }
  }
  .menu-item {
    > * + * {
      margin-top: 24px;
    }
  }
  .item {
    font-size: 20px;
    text-decoration: none;
    color: black;

    .title {
      margin: 12px 0;

      &.normal {
        font-size: 16px;
      }
    }
  }

  select {
    border: none;
    padding-left: 0;
    padding-right: 12px;
    margin-bottom: 100px;
  }
}

.slide-in-enter-active {
  transition: all 400ms ease-in;
}
.slide-in-leave-active {
  transition: all 400ms ease-in;
}
.slide-in-enter,
.slide-in-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>
